/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getShift} from '../api'

 export const useQueryGetShift = createReactQueryHook('getShift', getShift)
